import React from "react";
import PropTypes from "prop-types";
import { Flex } from "@domestika-dev/prudencio/dist/atoms/Layout";
import { Text } from "@domestika-dev/prudencio/dist/atoms/Typography";

const NumberedList = ({ items, marginTop }) => (
  <Flex
    flexDirection="column"
    justifyContent="flex-start"
    paddingLeft={[0, 3, 3]}
    marginTop={marginTop}
  >
    {items.map(({ headline, children }, index) => (
      <Flex key={`numbered-list-item-${index + 1}`} marginTop={index > 0 ? 5 : 0}>
        <Text size="tiny" textAlign="left" style={{ flexGrow: 0, flexShrink: 0, minWidth: "16px" }}>
          {index + 1}.
        </Text>
        <Flex flexDirection="column" justifyContent="flex-start" style={{ flexGrow: 1 }}>
          <Text size="tiny" textAlign="left">
            {headline}
          </Text>
          {children}
        </Flex>
      </Flex>
    ))}
  </Flex>
);

NumberedList.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      headline: PropTypes.string.isRequired,
      children: PropTypes.node,
    })
  ).isRequired,
  marginTop: PropTypes.oneOfType([PropTypes.number, PropTypes.arrayOf(PropTypes.number)]),
};

NumberedList.defaultProps = {
  marginTop: 0,
};

export default NumberedList;
